package org.matthewo.api

import kotlinx.serialization.Serializable

enum class AdvancementType {
    ELIM,
    AWARD,
}

@Serializable
data class EventCompetitionSimple(
    val number: Int,
    val name: String,
    val npOpr: Double,
    val opr: Double,
    val autoOpr: Double,
    val teleopOpr: Double,
    val endgameOpr: Double,
    val gameSpecific: GameSpecificStats? = null,
    val advancement: AdvancementType? = null,
)

@Serializable
sealed class GameSpecificStats

@Serializable
data class FreightFrenzyStats(val alliance: Double, val shared: Double) : GameSpecificStats()

@Serializable
data class IntoTheDeepStats(val specimen: Double, val sample: Double, val navigation: Double) : GameSpecificStats()

@Serializable
data class IntoTheDeepCRIStats(val specimen: Double, val sample: Double, val navigation: Double) : GameSpecificStats()
